import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const TooltipComponent = ({message}) => {
  return (
    <Tooltip title={<p className="text-center">{message}</p>} arrow placement="top" className="cursor-help" >
        <InfoOutlinedIcon sx={{fontSize:'15px', position:'relative', top: 1 }}/>
    </Tooltip>
  );
};

export default TooltipComponent